import {FC} from 'react'

import {useAuthContent} from '@/content/user/authentication'
import {useTranslation} from '@/i18n'

import {Alert, AlertVariant} from '../../alerts/Alert'

export const FormActivate: FC<React.PropsWithChildren<unknown>> = () => {
  const {t} = useTranslation()
  const {haveAccountActivateTitle} = useAuthContent().formAuth

  return <Alert variant={AlertVariant.info} description={t(haveAccountActivateTitle)} />
}
